import { cn } from '@/lib/utils';

import ArticleItem, { ArticleItemProps } from './RelatedArticleItem';

export type RelatedArticlesProps = {
  items: ArticleItemProps[];
  classNames?: {
    wrapper?: string;
  };
};

export default function RelatedArticles({
  items,
  classNames,
}: RelatedArticlesProps) {
  return (
    <div
      className={cn(
        'grid gap-8 md:grid-cols-2 md:gap-x-9 md:gap-y-12',
        classNames?.wrapper
      )}
    >
      {items.map((item, index) => (
        <ArticleItem key={index} {...item} />
      ))}
    </div>
  );
}
